module.exports = __webpack_public_path__ + "img/phone-blue-icon.3d64cf53.svg";